import * as React from 'react'
import checkUrlType from '../../../../../utils/url-type-checker';
import * as cn from 'classnames'
import { PackshotProps } from './Packshot';
import { StorefrontItemPlaybackAction, StorefrontLink } from 'DVWebNodeUtils';

interface PackshotContainerProps extends PackshotProps {
  classNames: string
  style?: React.CSSProperties
  children: React.ReactChild | React.ReactChild[]
}


interface LinkContainerProps {
  classNames: string
  style?: React.CSSProperties
  link: StorefrontLink
  children: React.ReactChild | React.ReactChild[]
  title: string
  playbackAction: StorefrontItemPlaybackAction
}

interface NoLinkContainerProps {
  classNames: string
  style?: React.CSSProperties
  link: StorefrontLink
  children: React.ReactChild | React.ReactChild[]
  title: string
  playbackAction: StorefrontItemPlaybackAction
}

const LinkContainer = ({ classNames, style, link, children, title }: LinkContainerProps) => (
  <div className={cn(classNames, 'tst-packshot-link')} style={style}>
    <a aria-label={title} href={checkUrlType(link.url, 'LinkContainer')}>
      {children}
    </a>
  </div>
)

const NoLinkContainer = ({ classNames, style, children, title }: NoLinkContainerProps) => (
  <div aria-label={title} className={classNames} style={style}>
    {children}
  </div>
)

function getContainerType(props: PackshotContainerProps) {
  if (!props.link) {
    return NoLinkContainer
  }
  if (props.isLive && !props.canLivePlayback) {
    // if the user browser is too old, we'll display an error message on the click
    if (!props.playbackAction) {
      // except if the user isn't entitled, in which case we will redirect to the sign up page
      return LinkContainer
    }
    return NoLinkContainer
  }
  return LinkContainer
}

const PackshotContainer = (props: PackshotContainerProps) => {
  const Container = getContainerType(props)
  return (
    <Container classNames={props.classNames}
      playbackAction={props.playbackAction}
      link={props.link}
      title={props.title}>
      {props.children}
    </Container>
  )
}

export default PackshotContainer
